import React, { useEffect, useState } from "react";
import styles from "../../../FacilityAdmin/Dashboard/FacilityDetails.module.scss";
import "./AdminAllBookingsDetails.scss";
import Loader from "../../../../components/Loader/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../Sidebar/Sidebar";
import { toast } from "react-toastify";
import LocationDropdown from "../../../Dashboard/VenueListComp/LocationDropdown";

// Modal Component
const CancelConfirmationModal = ({ isOpen, onClose, onConfirm, bookingId }) => {
  if (!isOpen) return null;

  return (
    <div className="modalOverlayAllBookingsDetails">
      <div className="modalContentAllBookingsDetails">
        <h3 className="titleAllBookingsDetails">Confirm Cancellation</h3>
        <p>Are you sure you want to cancel booking ID: {bookingId}?</p>
        <div className="modalButtonsAllBookingsDetails">
          <button
            onClick={onConfirm}
            className="confirmButtonAllBookingsDetails"
          >
            Yes
          </button>
          <button onClick={onClose} className="cancelButtonAllBookingsDetails">
            No
          </button>
        </div>
      </div>
    </div>
  );
};

const AdminAllBookingsDetails = () => {
  const [facilityData, setFacilityData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hideSvg, setHideSvg] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cancelError, setCancelError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const booking_id = location?.state?.member;
  const [status, setStatus] = useState("All");
  const [playerStatuses, setPlayerStatuses] = useState([]);

  useEffect(() => {
    const bookingsDetails = async () => {
      const token = localStorage.getItem("access_token");
      setLoading(true);
      const url = `https://ballersapi.ballerslife.co/api/v1/admin/admin/booking/${booking_id}`;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setFacilityData(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    if (booking_id) {
      bookingsDetails();
    }
  }, [booking_id]);

  useEffect(() => {
    if (
      facilityData &&
      facilityData.booking &&
      facilityData.booking.players_joined
    ) {
      setPlayerStatuses(
        facilityData.booking.players_joined.map((player) => {
          // Capitalize first letter of status if present
          const status = player.status;
          return (
            status?.charAt(0)?.toUpperCase() + status?.slice(1)?.toLowerCase()
          );
        })
      );
    }
  }, [facilityData]);

  const handleCancelBooking = async () => {
    const token = localStorage.getItem("access_token");
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/admin/cancel_booking?booking_id=${booking_id}`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to cancel booking");
      }

      const data = await response.json();
      if (response.status === 200) {
        toast.success(data.message || "Booking cancelled successfully");
        navigate("/admin/allbookings");
      } else {
        toast.error(data.message || "Failed to cancel booking");
      }
      // Assuming the API returns a success message or updated booking status
      setFacilityData({
        ...facilityData,
        booking: { ...facilityData.booking, status: "cancelled" },
      });
      setIsModalOpen(false);
    } catch (err) {
      setCancelError(err.message);
      setIsModalOpen(false);
    }
  };

  const handlePlayerStatusChange = async (index, newStatus) => {
    const player = booking.players_joined[index];
    const bookingId = booking.booking_id;
    const userId = player.user_id;
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/admin/update_member_booking_status?booking_id=${bookingId}&user_id=${userId}&new_status=${newStatus.toLowerCase()}`;
    const token = localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to update player status");
      }
      // console.log("Player status updated successfully", response);
      // Optionally, show a toast or update UI
      setPlayerStatuses((prev) => {
        const updated = [...prev];
        updated[index] =
          newStatus?.charAt(0)?.toUpperCase() +
          newStatus.slice(1)?.toLowerCase();
        return updated;
      });
    } catch (err) {
      // Optionally, show error toast
      // console.error(err);
    }
  };

  if (error) return <div>Error: {error}</div>;
  if (!facilityData) return <Loader />;
  const { booking } = facilityData;

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="goBackSvg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#FFBF00"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-left"
                onClick={() => navigate(-1)}
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </div>
            <div className={styles.facilityContainer}>
              <div className={styles.details}>
                {facilityData.cancel_available ? (
                  <div
                    className="fetchUserWrap"
                    style={{ marginLeft: "-20px" }}
                  >
                    <div className="fetchUserInfoBtn">
                      <div className="userBtnOPt">
                        <p
                          onClick={() => setIsModalOpen(true)}
                          style={{ color: "red", cursor: "pointer" }}
                        >
                          Cancel Booking
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                {cancelError && (
                  <div style={{ color: "red", marginBottom: "10px" }}>
                    Error: {cancelError}
                  </div>
                )}
                <div className={styles.infoSection}>
                  <p>
                    <strong className="faDTitle">Booking ID:</strong>{" "}
                    {booking.booking_id}
                  </p>
                  <p>
                    <strong className="faDTitle">Facility ID:</strong>{" "}
                    {booking.facility_id}
                  </p>
                  <p>
                    <strong className="faDTitle">City:</strong> {booking.city}
                  </p>
                  <p>
                    <strong className="faDTitle">Sport:</strong> {booking.sport}
                  </p>
                  <p>
                    <strong className="faDTitle">Booking Date:</strong>{" "}
                    {booking.booking_date}
                  </p>
                  <p>
                    <strong className="faDTitle">Booking Time:</strong>{" "}
                    {booking.booking_time}
                  </p>
                  <p>
                    <strong className="faDTitle">Duration:</strong>{" "}
                    {booking.duration} hour(s)
                  </p>
                  <p>
                    <strong className="faDTitle">Courts Requested:</strong>{" "}
                    {booking.courts_req}
                  </p>
                  <p>
                    <strong className="faDTitle">Players Required:</strong>{" "}
                    {booking.players_req}
                  </p>
                  <p>
                    <strong className="faDTitle">Status:</strong>{" "}
                    {booking.status}
                  </p>
                  <p>
                    <strong className="faDTitle">Created At:</strong>{" "}
                    {new Date(booking.created_at).toLocaleString()}
                  </p>
                  <p>
                    <strong className="faDTitle">Updated At:</strong>{" "}
                    {new Date(booking.updated_at).toLocaleString()}
                  </p>
                </div>
                <div className={styles.sportInfo}>
                  <h4>Players Joined:</h4>
                  {booking.players_joined.length > 0 ? (
                    booking.players_joined.map((player, index) => (
                      <div key={index} className={styles.playerRow}>
                        <p
                          style={{
                            display: "inline-block",
                            marginRight: "10px",
                          }}
                        >
                          <strong>{player.name}:</strong> {player.phone_no}{" "}
                          {player.name.includes("(host)") ? "(Host)" : ""}
                        </p>
                        {player.user_id && (
                          <div className={styles.dropdownAllBookingStatus}>
                            <label
                              className={styles.locationSelect}
                              htmlFor={`status-select-${index}`}
                            >
                              Status:
                            </label>
                            <LocationDropdown
                              location={playerStatuses[index]}
                              setLocation={(newStatus) =>
                                handlePlayerStatusChange(index, newStatus)
                              }
                              locationOptions={[
                                "Completed",
                                "Confirmed",
                                "Cancelled",
                                "Checked In",
                                "No Show",
                                "Pending",
                              ]}
                            />
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <p>No players joined yet.</p>
                  )}
                  <h4>Guest List:</h4>
                  {booking.guest_list.length > 0 ? (
                    booking.guest_list.map((guest, index) => (
                      <p key={index}>{guest.name}</p>
                    ))
                  ) : (
                    <p>No guests added.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <CancelConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleCancelBooking}
        bookingId={booking.booking_id}
      />
    </div>
  );
};

export default AdminAllBookingsDetails;
